import React, { useRef } from 'react';
import { registerWidget } from '@okapi/core';
import { FooterContainer } from 'entries/common';
import { createStore } from 'store';
import { FETCH_MODEL, SubscriptionEvents } from 'actions';
// @TODO: remove import when footer will be rewritten in react
import 'legacy-webcomponents/footer';
import { ModelJsonStore, SubscriptionStore } from 'reducers';

registerWidget<ModelJsonStore & SubscriptionStore>(`${__NAME__}/footer`, state => () => {
  const storeRef = useRef(createStore());
  storeRef.current.dispatch(FETCH_MODEL.success, state.model ?? undefined);
  storeRef.current.dispatch(SubscriptionEvents.setRecaptchaParams, {
    subscribersUrl: state.subscribersUrl,
    recaptchaPublicKey: state.recaptchaPublicKey,
    subscribersApiKey: state.subscribersApiKey,
  });

  return <FooterContainer store={storeRef.current} />;
});
